import { createFileRoute } from '@tanstack/react-router';
import { UsersTab } from '@/features/account/users/UsersTab';

export const Route = createFileRoute('/account/users')({
  component: UsersTab,
});
